import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { UsingTokenToroComponent } from './using-token-toro.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [UsingTokenToroComponent],
    declarations: [UsingTokenToroComponent],
})
export class UsingTokenToroModule { }
